
(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('threedsBridge', function($http, $window, $rootScope, analytics) {
    const hidden = '<input type="hidden" name="{0}" value="{1}" />';
    return {
        restrict: 'E',
        scope: {
            challengeUrl: '='
        },
        template: '<iframe id="threeframe" name="threeframe" frameBorder="0" width="100%" height="550px"></iframe>',
        link(scope) {
            // var frame = angular.element('#threeframe');
            //id="challengeForm" method="post"
            /*function back() {
                scope.$emit('3DSValidationCancelled');
                $($window).off('popstate', back);
            }*/

            //evil global used to obtain the results from 3ds validation. There's not really any other way.
            $window.threed3Callback = function(paRes, prePaymentId, md, paymentId) {
                //console.log('arguments', arguments);
                if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                    paRes = paRes.replaceAll('^', '');
                    if (paRes === 'CANCELLED') {
                        scope.$emit('3DSValidationCancel');
                    } else if (paRes !== 'CANCELLED') {
                        scope.$emit('3DSValidationComplete', {
                            paRes,
                            prePaymentId,
                            md,
                            paymentId
                        });
                    } else {
                        document.querySelector('.threeds-wrapper-new .close').click();
                    }
                } else {
                    scope.$emit('3DSValidationComplete', {
                        paRes,
                        prePaymentId,
                        md,
                        paymentId
                    });
                }
            };

            scope.$on('3DSValidationFinished', function(ev, isSuccess) {
                if (!_.isEmpty(scope.mixpanelData)) {
                    analytics.track('mixpanel', (isSuccess ? '3DS Finished' : '3DS Failed'), scope.mixpanelData);
                }
            });

            function getAuth(domainId, cardTypeId, currencyCode, orderCode) {
                try {

                    if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                        cardTypeId = 370;
                    }

                    let url = `/api2/payments/transactions/getcpgclienttoken?domainId=${domainId}&cardTypeId=${cardTypeId}&currencyCode=${currencyCode}&orderCode=${orderCode}`;
                    return fetch(url)
                        .then(res => res.json())
                        .then(data => {
                            let at = null;
                            if (data && data.AccessToken) {
                                at = data.AccessToken;
                            }
                            return at;
                        })
                        .catch(error => {
                            console.log('error', error);
                            return null;
                        });

                } catch (error) {
                    console.log('error', error);
                    return null;
                }
            }

            scope.$on('request3DSValidation', async function(ev, threedsData, mixpanelData = {}) {
                /* we can't do this as long as this bug is in effect:
                //https://github.com/angular/angular.js/issues/3924
                if($sniffer.history) {
                    $window.history.pushState(null, '', $location.path());
                    $($window).on('popstate', back);
                }
                */
                if (!_.isEmpty(mixpanelData)) {
                    scope.mixpanelData = mixpanelData;
                    analytics.track('mixpanel', '3DS Started', mixpanelData);
                }

                const threeDsVersion = threedsData.ChallengeJWT !== '' && threedsData.ChallengeJWT !== 'ChallengeJWT' ? 2 : 1;

                const challengeUrl = TRPCONFIG.Domain2.ThreeDS2ChallengeUrl;


                const actionUrl = threeDsVersion === 2 ? challengeUrl : threedsData.AcsUrl;

                const secureForm = angular.element(document.getElementById('threeform')).empty();

                secureForm.attr('target', 'threeframe');
                secureForm.attr('method', 'POST');
                secureForm.attr('action', actionUrl);
                secureForm.append(String.format(hidden, 'MD', threedsData.MD));
                secureForm.append(String.format(hidden, 'TermUrl', threedsData.TermUrl));
                secureForm.append(String.format(hidden, 'PaReq', threedsData.PaReq));
                secureForm.append(String.format(hidden, 'JWT', threedsData.ChallengeJWT));
                if (TRPCONFIG.Domain2.UseCpgUpdate) {
                    let domainId = TRPCONFIG.Domain.DomainId;
                    let cardTypeId = TRPCONFIG.Domain.CardTypeId;
                    let currencyCode = TRPCONFIG.Domain.CurrencyCode;
                    let orderCode = threedsData.MD;

                    let authToken = await getAuth(domainId, cardTypeId, currencyCode, orderCode);

                    secureForm.append(String.format(hidden, 'token', authToken));
                }
                secureForm[0].submit();
            });
        }
    };
});
})();
